import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../assets/images/Logo.svg';

function NotFound() {
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Back</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>
        </div>
      </div>
      <div className='not-found pfas-container'>
        <Row>
          <div className='page404'>
            <Col xs={12}>
              <div className='headline'>Page Not found</div>
              <div className='text'>
                The requested URL was not found on the server. If you entered
                the URL manually please check your spelling and try again.
              </div>
              <div className='text'>
                Or press the button below to back to Home page
              </div>
              <div className='center'>
                <Link to='/' className='pfas-btn-white-back'>
                  <div className='nav-text-back'>Back to Home page</div>
                </Link>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default NotFound;
